module.exports = __webpack_public_path__ + "img/logo-jg.db13e411.jpg";